import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule }   from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { PublishedPipe } from './pipes/published.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { AddCommasPipe } from './pipes/add-commas.pipe';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { LayoutComponent } from './layout/layout.component';
import { NavItemComponent } from './navItem/navItem.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LivePhotoComponent } from './livePhoto/livePhoto.component';
import { ContactBoxComponent } from './contactBox/contactBox.component';
import { WorkBoxComponent } from './workBox/workBox.component';
import { MaterialModule } from './material.module';

@NgModule({
    imports: [
      CommonModule,
      RouterModule,
      ReactiveFormsModule,
      FormsModule,
      MaterialModule,
    ],
    declarations: [
      PublishedPipe,
      TruncatePipe,
      AddCommasPipe,
      EllipsisPipe,
      ToolbarComponent,
      LayoutComponent,
      NavItemComponent,
      SidenavComponent,
      LivePhotoComponent,
      ContactBoxComponent,
      WorkBoxComponent
    ],
    providers: [],
    exports: [
      PublishedPipe,
      TruncatePipe,
      AddCommasPipe,
      EllipsisPipe,
      ToolbarComponent,
      LayoutComponent,
      NavItemComponent,
      SidenavComponent,
      LivePhotoComponent,
      ContactBoxComponent,
      WorkBoxComponent
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/app/components/components.module.ts